import * as types from './mutations-type'

const state = {
  styleIndex: 100 // 营销短信头部导航栏跳转下标
}

const mutations = {
  // 更新营销短信头部导航栏跳转下标
  [types.UPSTYLEINDEX](state, number) {
    state.styleIndex = number
  }
}

const getters = {
  getStyleIndex(state) {
    return state.styleIndex
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/home/market/index.js